// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"19707b7d","453":"16cb82e8"}[chunkId] + ".chunk.js";
};